<template>
	<div class="comment">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>商品评价
			</span>
			<div></div>
		</div>
		<!-- 评论列表 -->
		<div v-if="userList == ''">
			<img src="../../assets/nocomment.png" style="width: 50%; margin: 2.2rem auto;" />
			<div style="font-size: 13px; color:#A4A4A4;">暂无评论~</div>
			<van-button icon="edit" type="primary" size="small" block round color="#F1452F" style="width: 70%; margin: 6rem auto;"
			 @click="goScore">我要评论</van-button>
		</div>
		<van-list v-else :finished="finished" v-model="loading" finished-text="我是有底线的" @load="onLoad">
			<div class="main">
				<div class="list" v-for="(item,index) in userList">
					<div class="user" v-if="item.user != null">
						<img src="../../assets/touxiang.png" alt="" v-if="item.anonymous == 2">
						<img src="../../assets/user.png" alt="" v-else-if="item.user.image == null">
						<img :src="item.user.image | handleUrl" alt="" v-else>
						<span class="user-span" v-if="item.anonymous == 2">匿名</span>
						<span class="user-span" v-else>{{item.user.username}}</span>
						<div class="user_time">{{item.create_time}}</div>
					</div>
					<div class="user-msg" v-if="item.content == ''">该用户暂无评论</div>
					<div class="user-msg" v-else>{{item.content}}</div>
					<div class="user_img" v-if="item.image != null">
						<img @click="getImg(items)" v-for="items in item.image" :src="items | handleUrl" alt="">
						<van-image-preview v-model="show" :images="image"></van-image-preview>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userList: [],
				show: false,
				image: [],
				loading: true,
				finished: true,
				pages: 1
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/category/thirdpartyComment', {
				id: this.$route.query.id,
				page: this.pages,
				limit: 5
			}).then((res) => {
				if (res.data.code == 2) {
					this.pages++;
					for (var i in res.data.data) {
						this.userList.push(res.data.data[i])
					}
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			// onLoad() {
			// 	this.$axios.post(baseUrl + '/mobile/category/thirdpartyComment', {
			// 		id: this.$route.query.id,
			// 		page: this.pages,
			// 		limit: 5
			// 	}).then((res) => {
			// 		if (res.data.code == 2) {
			// 			this.pages++;
			// 			setTimeout(() => {
			// 				for (var i in res.data.data) {
			// 					this.userList.push(res.data.data[i])
			// 				}
			// 				// 加载状态结束
			// 				this.loading = false;

			// 			}, 500)
			// 		} else {
			// 			this.loading = false;
			// 			this.finished = true;
			// 		}
			// 	}).catch((err) => {
			// 		console.log(err);
			// 	});
			// },
			goScore() {
				this.$router.push({
					path: '/score',
					query: {
						id: this.$route.query.id
					}
				})
			},
			//预览图
			getImg(img) {
				this.show = true;
				this.image = [];
				this.image.push(baseUrl + '/uploads/' + img);
			}
		}
	}
</script>

<style scoped>
	@import "../detail/comment.css";
</style>



// WEBPACK FOOTER //
// src/components/class/tpcomment.vue